import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { FormControl, NativeSelect, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";

import * as actions from "../../store/actions/actionIndex";
// uitility function
import { maskedNumber, notify } from "../../helpers/utility";

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    container: {
        maxHeight: 440,
    },
    closeButton :
    {
        float: "right",
        border: "1px solid #137dcc",
        borderRadius: 50,
        width: 25,
        marginRight: -12,
        marginTop: -4,
        cursor:"pointer"
    },
    unParkButton : {
       cursor: "pointer",
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingLeft: "15px",
        paddingRight: "15px",
        border: "1px solid #137dcc",
        backgroundColor: "#137dcc",
        color: "#fff"
}
});

function CallInPark(props) {

    const { agentId, onParkCallData, parkData, onCallUnpark } = props; 
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedRows, setSelectedRows] = useState([]);   
    const rows = Array.from(props.parkData);
    const [confRoom, setConfRoom] = useState(1)

    useEffect(() => {
        if(props.campConf.call_park === "1"){
        const getCallData = setInterval(() => {
            onParkCallData(agentId);
        }, 3000);
        return () => {
            clearInterval(getCallData);
        };
    }
    }, [agentId, onParkCallData, props.campConf]);


    // const [parkId, setParkId] = useState("")


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    //Handle Unpark
    const handleCallUnpark = (parkId) =>{
     onCallUnpark(agentId,parkId )
     props.showQueueDetails(false)
    }
    //Checkbox handle
    const handleCheckboxChange = (row) => {
    setSelectedRows((prev) => {
    if (prev.find((r) => r.call_park_id === row.call_park_id)) {
      return prev.filter((r) => r.call_park_id !== row.call_park_id);
    } else {
      return [...prev, row];
    }
  });
};
useEffect(() => {
  setSelectedRows((prevSelected) =>
    prevSelected.filter((row) =>
      parkData.some((data) => data.call_park_id === row.call_park_id)
    )
  );
}, [parkData]);

const handleBridge = () => {
  if (selectedRows.length > 2) {
    notify("You can only select two calls at a time for bridge.");
    return;
  }

  if (selectedRows.length < 2) {
    notify.error("Please select two calls to start a bridge.");
    return;
  }

  // Proceed only if exactly 2 rows are selected
  selectedRows.forEach((row) => {
    props.onJoinConf(
      agentId,
      "transfer",
      confRoom,
      row.phone_no,
      "1",
      row.call_park_id
    );
  });

  props.showQueueDetails(false);
};


    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                        <TableRow style={{ height: "20px" }}>
                            <TableCell key={0} align="center" colSpan={5}>
                               Park Call Details
                                <span onClick={() => props.showQueueDetails(false)} className={classes.closeButton}>X</span>
                            </TableCell>
                        </TableRow>
                    </TableHead>
<TableHead>
  <TableRow style={{ height: "20px" }}>
    {parkData && parkData.length > 0 ? (
      <>
        <TableCell>Select</TableCell>
        {Object.keys(parkData[0] || {}).map((key) => (
          <TableCell key={key} style={{ minWidth: 100 }}>
            {key
              .split('_')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')}
          </TableCell>
        ))}
        <TableCell>Call Type</TableCell>
      </>
    ) : (
      <TableCell colSpan={10}>No Call in the Park yet</TableCell>
    )}
  </TableRow>
</TableHead>


<TableBody>
  {parkData && parkData.length > 0 && parkData.map((row, rowIndex) => (
    <TableRow key={rowIndex} style={{ height: "20px" }}>
      <TableCell>
        <input
          type="checkbox"
          checked={selectedRows.find((r) => r.call_park_id === row.call_park_id) !== undefined}
          onChange={() => handleCheckboxChange(row)}
        />
      </TableCell>
      {Object.keys(row).map((key) => (
        <TableCell key={key}>
          {props.facilityConf?.enable_number_mask === "1" && key === "phone_no"
            ? maskedNumber(row[key], props.facilityConf.mask_start_pos, props.facilityConf.mask_end_pos)
            : row[key]}
        </TableCell>
      ))}
      <TableCell>
        <button className={classes.unParkButton} onClick={() => handleCallUnpark(row.call_park_id)}>Unpark</button>
      </TableCell>
    </TableRow>
  ))}
</TableBody>
 </Table>
  </TableContainer>
  {selectedRows.length >= 2 && (
    <div className="" style={{display: "flex", padding: "0 20px", justifyContent: "space-between", alignItems: "center"}}>
      <div>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        style={{ margin: "0px" }}
                      >
                        <NativeSelect
                          className={classes.selectEmpty}
                          value={confRoom}
                          name="age"
                          onChange={(e) => setConfRoom(e.target.value)}
                          inputProps={{ "aria-label": "age" }}
                        //   disabled={multiConf ? false : true}
                          style={{
                            paddingTop: "16px",
                            paddingBottom: "16px",
                          }}
                        >
                          <option value={1}>&nbsp;Conf Room 1</option>
                          <option value={2}>&nbsp;Conf Room 2</option>
                          <option value={3}>&nbsp;Conf Room 3</option>
                        </NativeSelect>
                      </FormControl>
                    </div>
  <div style={{ textAlign: "center", margin: "10px 0" }}>
    <button className={classes.unParkButton} onClick={handleBridge}>
      Bridge
    </button>
  </div>
  </div>
)}
   <TablePagination rowsPerPageOptions={[10, 25, 100]} component="div" count={rows.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
        </Paper>
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state.queueCalls.loading,
        error: state.queueCalls.error,
        agentId: state.agentData.agentId,
        queueCallData: state.queueCalls.queueCallData,
        campConf: state.agentConfig.campConf,

    };
    
};

const mapDispatchToProps = (dispatch) => {
    return {
        onJoinConf: (agentId, cond, confRoom,phoneNo, isParkCall, parkId) => dispatch(actions.joinConf(agentId, cond, confRoom,phoneNo,isParkCall, parkId)),
       onParkCallData:(agentId) => dispatch(actions.parkCallStatus(agentId)),
       onCallUnpark : (agentId, parkId) => dispatch(actions.callUnPark(agentId, parkId))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CallInPark);